import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export default function Sidebar() {
  const location = useLocation();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <aside className="sidebar">
      <Link to="/" className="sidebar-title">
        Strona główna
      </Link>
      <nav>
        <Link
          to="/obligacje"
          className={`sidebar-tab${location.pathname === '/obligacje' ? ' active' : ''}`}
        >
          Obligacje
        </Link>
      </nav>
      <div className="sidebar-footer">
        <button onClick={handleLogout} className="logout-button">
          Wyloguj się
        </button>
      </div>
    </aside>
  );
} 